import React from 'react';
import { FormField, Input } from 'components/alf-design';

const UserProfileField = ({
  label,
  name,
  type = 'text',
  value,
  touched,
  errors,
  status,
  onChange,
  onBlur,
  successCriteria,
  errorCriteria,
  hideErrorMessage = false,
  compact = false,
}) => {
  const showError = touched && (status === 'invalid' || !!errors);
  const showSuccess = Boolean(successCriteria) && !showError;

  return (
    <FormField
      label={label}
      error={hideErrorMessage ? '' : errorCriteria}
      labelTypographyType="h3"
      dense={hideErrorMessage || compact}
    >
      <Input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={showError}
        success={showSuccess}
      />
    </FormField>
  );
};

export default UserProfileField;
